import { Arrow, Content, Portal, Root, Trigger } from '@radix-ui/react-tooltip';
import { type ComponentProps, type ReactElement } from 'react';
import { cn } from '@avanta/shared/utils/cn';
import { tooltipStyles } from './styles';

const Tooltip = ({ ...props }: ComponentProps<typeof Root>): ReactElement => (
  <Root data-slot="tooltip" {...props} />
);

const TooltipTrigger = ({ ...props }: ComponentProps<typeof Trigger>): ReactElement => (
  <Trigger data-slot="tooltip-trigger" {...props} />
);

const TooltipContent = ({
  className,
  sideOffset = 0,
  children,
  ...props
}: ComponentProps<typeof Content>): ReactElement => (
  <Portal>
    <Content
      data-slot="tooltip-content"
      sideOffset={sideOffset}
      className={cn(tooltipStyles.content, className)}
      {...props}
    >
      {children}
      <Arrow className={tooltipStyles.arrow} />
    </Content>
  </Portal>
);

export { Tooltip, TooltipTrigger, TooltipContent };
